import React from 'react'

import { t } from 'src/lib/i18n-react'
import { Grid } from '@chatterbug/aaron'

const AppointmentTrainingLabel: React.FC = () => {
  return (
    <Grid
      data-testid="training-lesson"
      alignSelf="flex-start"
      bg="pink51"
      px="1x"
      py="0,5x"
      borderRadius="4px"
      as="p"
      variant="text.tinyTitle"
      color="white100"
    >
      {t('Training Lesson')}
    </Grid>
  )
}

export default AppointmentTrainingLabel
